import { env } from '../common/env';

import ajax from './ajax';

export interface Certificate {
    _id: string;
    certificateId: string;
    examId: any;
    attemptId: string;
    userId: string;
    certificateData: {
        certificateId: string;
        examTitle: string;
        userName: string;
        score: number;
        passed: boolean;
        issuedDate: string;
    };
    verificationCode: string;
    issuedAt: string;
    expiresAt?: string;
    revokedAt?: string;
}

export interface CertificateVerification {
    valid: boolean;
    message?: string;
    certificate?: {
        certificateId: string;
        userName: string;
        examTitle: string;
        score: number;
        issuedAt: string;
    };
}

class CertificateService {
    async getMyCertificates(params: { page?: number; limit?: number } = {}): Promise<{ certificates: Certificate[]; total: number }> {
        const queryParams = new URLSearchParams();
        if (params.page) queryParams.append('page', String(params.page));
        if (params.limit) queryParams.append('limit', String(params.limit));
        const query = queryParams.toString();
        return ajax.get(`/api/certificates/my${query ? `?${query}` : ''}`);
    }

    /** Public — no auth required. */
    async verify(code: string): Promise<CertificateVerification> {
        return ajax.get(`/api/certificates/verify/${encodeURIComponent(code)}`);
    }

    async generate(attemptId: string): Promise<Certificate> {
        return ajax.post('/api/certificates/generate', { attemptId });
    }

    /** Opens the printable certificate document in a new tab. */
    openCertificate(certificate: Certificate): void {
        const url = `${env.apiBaseUrl}/api/certificates/${encodeURIComponent(certificate.certificateId)}/download`;
        window.open(url, '_blank', 'noopener');
    }
}

export default new CertificateService();
